import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import {Router} from "@angular/router";
import { FormGroup, FormControl, AbstractControl, FormBuilder, Validators} from '@angular/forms';

import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { CustomValidators } from 'ng2-validation';

import { Utilisateur } from '../../model/utilisateur.model';
import { UtilisateurService } from '../../service/utilisateur.service';
import { Resultat } from '../../model/resultat.model';


@Component({
   selector: 'ms-forgot-password',
   templateUrl:'./forgot-password-component.html',
   styleUrls: ['./forgot-password-component.scss'],
   encapsulation: ViewEncapsulation.None,
})
export class ForgotPasswordComponent implements OnInit {

  public form:FormGroup;
  public email:AbstractControl;

  autoHide = 3000;
  addExtraClass = false;
  actionButtonLabel = 'Retry';
  action = false;

  constructor(
    private router: Router,
    private fb:FormBuilder,
    public snackBar: MatSnackBar,
    private utilisateurService: UtilisateurService
  ) {


    this.form = fb.group({
      'email': ['', Validators.compose([Validators.required, CustomValidators.email])]
    });
    this.email = this.form.controls['email'];
   }

   onSubmit(user) {
    const config = new MatSnackBarConfig();
    var mailuser = new Utilisateur();
    mailuser.login = user.email;
    this.utilisateurService.resetpassword(mailuser).subscribe(res =>{

      if(res.code == '000'){
        config.duration = this.autoHide;
        config.extraClasses = this.addExtraClass ? ['party'] : null;
        this.snackBar.open('Votre mot de passe a été  réinitialisé. Veuillez consulter votre email.', this.action && this.actionButtonLabel, config);
        this.router.navigate(['/authentication/login']);
      } else {

        config.duration = this.autoHide;
        config.extraClasses = this.addExtraClass ? ['party'] : null;
        this.snackBar.open('Email incorrect.', this.action && this.actionButtonLabel, config);

      }
    });

   // console.log(user);


  }

  ngOnInit() {
  }

}






// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/session/forgot-password/forgot-password.component.ts